import React from "react";
import ReactGA from 'react-ga';
export default class PrivacyPolicy extends React.Component {

    componentDidMount() {
        ReactGA.pageview(window.location.href, [], "Privacy Policy");
    }
    render() {
        return (
            <main id="main">
                <section className="inner-page">
                    <div className="container">
                        <article className="prose lg:prose-lg mx-auto">
                            <h1>Privacy Policy</h1>
                            <p><em>Effective Date: September 24, 2025</em></p>
                            <p>Welcome to ExpenseGenie. <a href="https://kishanpanchal.in">Coderman401</a> ("us", "we", or "our") operates the <a href="https://expense-genie.web.app"> https://expense-genie.web.app</a> website and the ExpenseGenie mobile application . Our Privacy Policy explains how we collect, use, disclose, and protect information that applies to our Service, and your choices about the collection and use of your information. </p>

                            {/* <p>Welcome to ExpenseGenie. This Privacy Policy describes how we handle your information on our website and Android application.</p> */}
                            <h2>1. Website Privacy</h2>
                            <p>Our website (<a href="https://expense-genie.web.app">https://expense-genie.web.app</a>) does <strong>not</strong> collect any personal data from visitors. There is no login functionality, and we do not request or store any user information.</p>
                            <p>We use Google Tag Manager solely for analytics purposes to understand website usage and improve our services. No personally identifiable information is collected or stored through analytics.</p>
                            <h2>2. Android Application Privacy</h2>
                            <p>Our Android app uses Firebase Anonymous Authentication and Google Sign-In to authenticate users. During Google login, we request your mobile number to uniquely identify your account and store your transactions in our Firebase database.</p>
                            <h3>Data We Collect:</h3>
                            <ul>
                                <li><strong>Email address</strong> (from Google Sign-In)</li>
                                <li><strong>Mobile number</strong> (provided by you during login)</li>
                            </ul>
                            <h3>How We Use Your Data:</h3>
                            <ul>
                                <li>To authenticate and identify users</li>
                                <li>To store and manage your transaction data (using your mobile number as a unique key)</li>
                                <li>All transaction data is encrypted and securely stored in Firebase</li>
                                <li>We do <strong>not</strong> share your data with any third parties</li>
                            </ul>
                            <h3>Data Security:</h3>
                            <p>All sensitive data, including transactions, is encrypted. We take reasonable measures to protect your information.</p>
                            <h3>Account Deletion:</h3>
                            <p>Currently, there is no in-app option to delete your account or data. However, we are working to implement this feature soon, so you will be able to easily remove your data from the application.</p>
                            <h2>3. Changes to This Policy</h2>
                            <p>We may update this Privacy Policy from time to time. Any changes will be communicated through the app or website.</p>
                            <h2>4. Contact Us</h2>
                            <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:coderman401.ai@gmail.com">coderman401.ai@gmail.com</a>.</p>
                            <p><strong>Coderman401</strong><br />ExpenseGenie Team</p>
                        </article>
                    </div>
                </section>
            </main>
        );
    }
}
